import { useTranslation } from 'react-i18next'

import { useDateLimits, useScreen } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import { CONTRACT_FORM_FIELD_NAME_END_DATE } from '../../../Contract.constants'

function EndDateField() {
  const { t } = useTranslation()

  const { maxDate, minDate } = useDateLimits()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={DatePicker}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Contract.EndDateLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      maxValue={maxDate}
      minValue={minDate}
      name={CONTRACT_FORM_FIELD_NAME_END_DATE}
      placeholder={t('Contract.DatePlaceholderKey')}
    />
  )
}

export default EndDateField
